import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Responsive from '../assets/config/Responsive';
import RedDot from '../assets/icons/JSX/RedDot';
import Colors from '../assets/styles/Colors';
// 
// 
// 
const NotificationPanel = () => {

    // navigate
    const navigate = useNavigate();

    return (
        <Card>
            <Title>
            Notifications
            </Title>

            <Notification onClick={() => navigate('/notification-details')}>
               <NotificationTitle><RedDotStyle/>Lorem ipsum dummy Text is...</NotificationTitle>
               <NotificationText>Lorem ipsum dummy Text Lorem ipsum dummy</NotificationText>
               <HorizontalLine/>
            </Notification>

            <Notification>
               <NotificationTitle><RedDotStyle/>Lorem ipsum dummy Text is...</NotificationTitle>
               <NotificationText>Lorem ipsum dummy Text Lorem ipsum dummy</NotificationText>
               <HorizontalLine/>
            </Notification>

            <Notification>
               <NotificationTitle><RedDotStyle/>Lorem ipsum dummy Text is...</NotificationTitle>
               <NotificationText>Lorem ipsum dummy Text Lorem ipsum dummy Text</NotificationText>
               <HorizontalLine/>
            </Notification>

            <Notification>
               <NotificationTitle><RedDotStyle/>Lorem ipsum dummy Text is...</NotificationTitle>
               <NotificationText>BA-839-IK</NotificationText>
            </Notification>
        </Card>
    )
}

//
const Card = styled.div`
    display: block;

    ${Responsive.mobile}{
        display: none;
    }
`;
const Notification = styled.div`
    cursor: pointer;
`;
const NotificationTitle = styled.div`
    color: ${Colors.primaryBlack};
    margin-left: -6px;
`;
const NotificationText = styled.div`
    color: ${Colors.primaryGrey};
`;
const RedDotStyle = styled(RedDot)`
    margin-left: -7px;
    margin-right: 7px;
    margin-top: -5px;
`;
const Title = styled.div`
    margin-bottom: 20px;
`;
const HorizontalLine = styled.hr`
  color: ${Colors.secondaryGrey};
  padding-bottom: 15px;
  margin: 0px;
  margin-top: 15px;
  opacity: unset;
`;
export default NotificationPanel